module.exports = __webpack_public_path__ + "static/media/minus.25df141b.svg";